export default {
    meta: {
        label: 'Español'
    },
    data: {
        'es': {
            97: [['🐿', 'ardilla'], ['⚓️', 'ancla'], ['🍍', 'ananá'], ['🚑', 'ambulancia'], ['🐝', 'abeja'], ['🥜', 'almendras']],
            98: [['🍌', 'banana'], ['👶', 'bebé'], ['🥔', 'batata'], ['🥦', 'brócoli'], ['🥖', 'baguette'], ['🥓', 'bacon'], ['🚲', 'bicicleta'], ['🦉', 'búho']],
            99: [['🦐', 'camarón'], ['🍫', 'chocolate'], ['🐊', 'cocodrilo'], ['☕', 'café'], ['🥄', 'cuchara'], ['🏠', 'casa'], ['🚗', 'carro']],
            100: [['🦕', 'dinosaurio'], ['🍩', 'dona'], ['🎲', 'dado'], ['💵', 'dinero'], ['🐉', 'dragón']],
            101: [['🐘', 'elefante']],
            102: [['👻', 'fantasma'], ['🍓', 'frutilla']],
            103: [['🦍', 'gorila'], ['🐱', 'gato'], ['🐔', 'gallina']],
            104: [['🚁', 'helicóptero'], ['🍄', 'hongo'], ['🐜', 'hormiga'], ['🍦', 'helado']],
            105: [['⛪', 'iglesia']],
            106: [['🦒', 'jirafa'], ['🐗', 'jabalí']],
            107: [['🥝', 'kiwi']],
            108: [['🐺', 'lobo'], ['🦁', 'león']],
            109: [['🐵', 'mono'], ['🦇', 'murciélago'], ['🍎', 'manzana'], ['🦋', 'mariposa']],
            110: [['👃', 'nariz'], ['🌃', 'noche'], ['☁', 'nube']],
            111: [['👂', 'oreja'], ['👁', 'ojo'], ['🐑', 'oveja']],
            112: [['🐼', 'panda'], ['🐷', 'puerco'], ['🐧', 'pingüino'], ['🦆', 'pato'], ['🐟', 'pez'], ['🤡', 'payaso'], ['📰', 'periódico']],
            113: [['🧀', 'queso']],
            114: [['🤖', 'robot'], ['🐭', 'ratón']],
            115: [['🧜', 'sirena'], ['🍣', 'sushi'], ['🐍', 'serpiente'], ['🍉', 'sandía']],
            116: [['🐆', 'tigre'], ['🐢', 'tortuga'], ['🌮', 'taco']],
            117: [['🦄', 'unicornio'], ['🍇', 'uva']],
            118: [['🐮', 'vaca'], ['🧛‍♂️', 'vampiro'], ['🌋', 'volcán']],
            119: [],
            121: [['☯️', 'yin e yang']],
            122: [['🦓', 'zebra'], ['🧟', 'zombi'], ['🥕', 'zanahoria'], ['🦊', 'zorro']]
        }
    }
};
